var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span class=\"cursor-pointer\"><ng-transclude></ng-transclude><span ng-if=\"orderKey() === &quot;-&quot; + sortColumn\"><span class=\"dropup\">&nbsp;<span class=\"caret\"></span></span></span><span ng-if=\"orderKey() === sortColumn\">&nbsp;<span class=\"caret\"></span></span></span>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/directives/sorted-column.jade
 ** module id = 832
 ** module chunks = 0 1 3 4 5 6
 **/